module.exports = __webpack_public_path__ + "static/screenshot1-86ed01c50d4f83eefa49c1d5c55337ff.png";